import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

 // public url : string;
  private BASE_URL:string = window["cfgApiBaseUrl"];
  private COMMENT_URL:string = this.BASE_URL+"comment";
  public formSubmitted : boolean;
  private _comment: Array<Icomment>;
  
  constructor(private http : HttpClient) { }

  public get comment(): Array<Icomment> {
    return this._comment;
  }



  public getComment(tccno : string):Observable<any>{
    //this.url = "https://eservices.lra.gov.lr/tccApp/api/comment/"+tccno;
    //this.url = "http://10.0.16.73:8093/tccApp/api/comment/"+tccno;
    //this.url = "http://localhost:8081/tccApp/api/comment/"+tccno;
    return this.http.get<any>(this.COMMENT_URL+"/"+tccno).pipe(
      map( res =>{
        this._comment = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  public addComment(commentform){
    //this.url = "https://eservices.lra.gov.lr/tccApp/api/comment"
    //this.url = "http://10.0.16.73:8093/tccApp/api/comment";
   // this.url = "http://localhost:8081/tccApp/api/comment";
    const comm: Icomment = { USER_COMMENT: commentform.comments, 
                             USERGROUP: commentform.usergroup, 
                             COMMENT_DATE: Date.now().toString()
                            };
    return this.http.post<any>(this.COMMENT_URL, commentform)
                    .pipe(catchError(this.errorHandler))
                    .pipe(tap( data =>{
                                this._comment.push(comm);
                          }));
  }

  errorHandler(error : HttpErrorResponse){
   // console.log(error);
    return observableThrowError(error.message || "Server Error");
  }
}
